import { render, staticRenderFns } from "./plainTextLayerDrawer.vue?vue&type=template&id=7efbfdf6&"
import script from "./plainTextLayerDrawer.vue?vue&type=script&lang=ts&"
export * from "./plainTextLayerDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./plainTextLayerDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports